<div class="property-card" [class.property-card--list]="cardVariant === 'list'" [class.property-card--favorites]="cardVariant === 'favorites'" (click)="onCardClick()">
  <div
    class="property-card-image"
    [class.property-card-image--touch]="touchGallery && photoCount > 1">
    <ng-container *ngIf="touchGallery && photoCount > 1; else staticPhoto">
      <div
        #photoViewport
        class="property-card-photo-viewport"
        [class.property-card-photo-viewport--dragging]="isPhotoDragging"
        (touchstart)="onPhotoDragStart($event)"
        (touchmove)="onPhotoDragMove($event)"
        (touchend)="onPhotoDragEnd()">
        <div
          #photoTrack
          class="property-card-photo-track property-card-photo-track--windowed"
          [class.property-card-photo-track--dragging]="isPhotoDragging"
          [class.property-card-photo-track--snapping]="snapWithoutTransition"
          [style.transform]="getPhotoTrackTransform()"
          (transitionend)="onPhotoTrackTransitionEnd($event)">
          <div
            class="property-card-photo-slot"
            *ngFor="let slide of windowedPhotoSlides; trackBy: trackWindowedSlide">
            <img
              *ngIf="windowedSlideUrl(slide.photoIndex) as slideUrl"
              class="property-card-photo"
              [src]="slideUrl"
              width="400"
              height="300"
              [alt]="streetAddress"
              [attr.loading]="windowedSlideLoading(slide.photoIndex)"
              decoding="async"
              (load)="slide.role === 'current' && onCenterSlideLoad()" />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #staticPhoto>
      <img
        *ngIf="currentImageUrl && photoLoading === 'eager'"
        fill
        priority
        class="property-card-photo"
        [ngSrc]="currentImageUrl"
        sizes="(min-width: 1200px) 25vw, 100vw"
        [alt]="streetAddress"
        decoding="async" />
      <img
        *ngIf="currentImageUrl && photoLoading !== 'eager'"
        fill
        class="property-card-photo"
        [ngSrc]="currentImageUrl"
        sizes="(min-width: 1200px) 25vw, 100vw"
        [alt]="streetAddress"
        decoding="async" />
    </ng-template>

    <div class="property-card-gradient" aria-hidden="true"></div>

    <span
      *ngIf="statusBadge as badge"
      class="listing-status-badge"
      [class.listing-status-badge--pending]="badge.variant === 'pending'"
      [class.listing-status-badge--contingent]="badge.variant === 'contingent'"
      [class.listing-status-badge--fresh]="badge.variant === 'fresh'"
      [class.listing-status-badge--neutral]="badge.variant === 'neutral'">
      {{ badge.label }}
    </span>

    <button
      *ngIf="photoCount > 1"
      type="button"
      class="property-card-arrow property-card-arrow--left"
      aria-label="Previous photo"
      (click)="showPrevPhoto($event)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path d="M14.91 6.71a1 1 0 0 0 0 1.41L11.23 12l3.68 3.88a1 1 0 0 1-1.45 1.37l-4.41-4.65a1 1 0 0 1 0-1.37l4.41-4.65a1 1 0 0 1 1.45 1.37z" fill="currentColor"/>
      </svg>
    </button>

    <button
      *ngIf="photoCount > 1"
      type="button"
      class="property-card-arrow property-card-arrow--right"
      aria-label="Next photo"
      (click)="showNextPhoto($event)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path d="M9.09 6.71a1 1 0 0 1 0 1.41L12.77 12l-3.68 3.88a1 1 0 0 0 1.45 1.37l4.41-4.65a1 1 0 0 0 0-1.37l-4.41-4.65a1 1 0 0 0-1.45 1.37z" fill="currentColor"/>
      </svg>
    </button>

    <div *ngIf="photoCount > 1" class="property-card-dots">
      <span
        *ngFor="let dot of dotIndices"
        class="property-card-dot"
        [class.property-card-dot--active]="activeDot === dot && pulseDot === null"
        [class.property-card-dot--previous]="pulseDot === dot"
        aria-hidden="true"></span>
    </div>

    <button
      *ngIf="!isBuildingCard"
      type="button"
      class="property-card-like"
      [attr.aria-label]="isFavorited ? 'Remove from favorites' : 'Save property'"
      (click)="toggleFavorite($event)">
      <svg
        class="property-card-like-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        aria-hidden="true">
        <path [attr.d]="favoriteIconPath" fill="currentColor"/>
      </svg>
    </button>
  </div>

  <div class="property-card-details">
    <div class="property-card-price">{{ priceLabel }}</div>
    <div *ngIf="statSegments.length" class="property-card-stats">
      <ng-container *ngFor="let segment of statSegments; let last = last">
        <span class="property-card-stat-group">
          <span class="property-card-stat-value">{{ segment.value }}</span>
          <span class="property-card-stat-label">{{ segment.label }}</span>
        </span>
        <span *ngIf="!last" class="property-card-stat-divider" aria-hidden="true">|</span>
      </ng-container>
    </div>
    <div class="property-card-address">{{ locationLabel }}</div>
  </div>
</div>
